import React, { Component } from 'react'
import axios from 'axios'

import { Select } from '@softwaredev_cegeka/stix-form-select'
import { Dropdown } from '@softwaredev_cegeka/stix-core'

import { UserDataContext } from 'src/components/auth/withAuth'

class ImpersonateOrganizationMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            userData: {},
            userOrganizations: {},
        }
    }

    static contextType = UserDataContext

    componentDidMount() {
        this.setState({ userData: this.context.data })
        this.loadOrganizations(this.context.data.username)
    }

    loadOrganizations = username => {
        const { userData } = this.state
        this.setState({ loading: true })
        if (!userData.is_local_user) {
            axios
                .get(`/api/auth/users/${username}/tenants`)
                .then(response => {
                    if (response.data) {
                        this.setState({
                            userOrganizations: response.data.tenants,
                        })
                    }
                })
                .catch(_ => {
                    this.setState({ userOrganizations: [] })
                })
        }
    }

    organizationData() {
        return this.state.userOrganizations.map(organization => ({
            value: organization.organization_id,
            label: organization.name,
            id: organization.id,
        }))
    }

    handleOrganizationChange = chosen => {
        if (!chosen) {
            axios
                .delete('/api/auth/impersonator', {
                    params: {
                        organization_only: true,
                    },
                })
                .then(response => {
                    let permissions = null
                    this.getPermissions(this.context.data.username, null)
                        .then(permissionResponse => {
                            const { app_permissions } = permissionResponse.data
                            if (
                                !app_permissions ||
                                app_permissions.length === 0
                            ) {
                                permissions = []
                            } else {
                                permissions = app_permissions[0].actions
                            }
                            this.context.setImpersonatedOrganization(
                                response.headers.authorization,
                                null,
                                permissions
                            )
                        })
                        .catch(e => {
                            console.error(e)
                        })
                })
                .catch(e => {
                    console.error(e)
                })
        } else {
            axios
                .post('/api/auth/impersonator', {
                    organization_id: chosen.value,
                })
                .then(response => {
                    let permissions = null
                    this.getPermissions(
                        this.context.data.username,
                        chosen.value
                    )
                        .then(permissionResponse => {
                            const { app_permissions } = permissionResponse.data
                            if (
                                !app_permissions ||
                                app_permissions.length === 0
                            ) {
                                permissions = []
                            } else {
                                permissions = app_permissions[0].actions
                            }
                            this.context.setImpersonatedOrganization(
                                response.headers.authorization,
                                chosen,
                                permissions
                            )
                        })
                        .catch(e => {
                            console.error(e)
                        })
                })
                .catch(e => {
                    console.error(e)
                })
        }
    }

    getPermissions(username, organization) {
        let params = {}
        if (organization) {
            params.organization_id = organization
        }
        return axios.get(`/api/auth/users/${username}/app-permissions`, {
            params,
        })
    }

    renderOrganizationImpersonate() {
        const { userOrganizations } = this.state
        return userOrganizations.length > 1 ? (
            <>
                <Dropdown.Header>Change organization</Dropdown.Header>
                <Select
                    label={'Selected customer'}
                    srOnly
                    options={this.organizationData()}
                    isSearchable
                    isClearable
                    menuIsOpen
                    onChange={this.handleOrganizationChange}
                    value={this.context.impersonatedOrganization}
                    placeholder={'Filter Customers'}
                />
            </>
        ) : null
    }

    render() {
        const { userData } = this.state
        return !userData.is_local_user ? (
            <div className={'organization-menu'}>
                {this.state.userOrganizations.length > 1 &&
                    this.renderOrganizationImpersonate()}
            </div>
        ) : null
    }
}

export default ImpersonateOrganizationMenu
